import { IFragmentFragmentScreenDTO } from 'business/models/Models';
import React from 'react';
import { FragmentInfo } from './FragmentInfo';
import { RoundValue } from 'utils/Global';

const proteinInfoDisplay = (proteinInfoArray) => {
  return proteinInfoArray.map((data, i) => {
    return (
      <div
        id={`ingredientproteininfo-proteininfodisplay-${i}-wrapper`}
        key={`proteinInfo-${i}`}
        className="flex flex-row gap-2"
      >
        <div id={`ingredientproteininfo-proteininfodisplay-${i}-title`}>{data.title}</div>
        <div id={`ingredientproteininfo-proteininfodisplay-${i}-value`}>{data.value}</div>
      </div>
    );
  });
};

export interface IIngredientProteinInfo {
  isScreenRoute: any;
  proteinInfo: any;
  seedInfo: any;
  proteinIngredientsHTML: any;
  standardIngredientHTML: any;
  well: any;
  fragmentIds?: IFragmentFragmentScreenDTO[];
}
function IngredientProteinInfo(props: IIngredientProteinInfo) {
  const {
    isScreenRoute,
    proteinInfo,
    seedInfo,
    proteinIngredientsHTML,
    standardIngredientHTML,
    well,
    fragmentIds = [],
  } = props;

  if (!well) {
    return;
  }

  const proteinInfoArray = [
    {
      title: 'Drop:',
      value: proteinInfo?.dropNumber,
    },
    {
      title: 'Drop Protein Volume:',
      value:
        proteinInfo?.dropProteinVolume &&
        `${RoundValue(proteinInfo?.dropProteinVolume)} µL`,
    },
    {
      title: 'Well Volume:',
      value:
        proteinInfo?.dropWellVolume && `${RoundValue(proteinInfo?.dropWellVolume)} µL`,
    },
    {
      title: 'Name:',
      value: proteinInfo?.name,
    },
    {
      title: 'Protein Lot ID:',
      value: proteinInfo?.proteinLotId,
    },
    {
      title: 'Volume (µL):',
      value: proteinInfo?.volume && RoundValue(proteinInfo?.volume),
    },
    {
      title: 'Date Prepared:',
      value: proteinInfo?.datePrepared
        ? `${new Date(proteinInfo?.datePrepared).getFullYear()}-${
            new Date(proteinInfo?.datePrepared).getMonth() + 1
          }-${new Date(proteinInfo?.datePrepared).getDate()} ${new Date(
            proteinInfo?.datePrepared,
          ).toLocaleTimeString('en-US')}`
        : ``,
    },
    {
      title: 'Storage Temp. (°C):',
      value: proteinInfo?.storageTemp,
    },
    {
      title: 'Class:',
      value: proteinInfo?.pclass,
    },
    {
      title: 'Ext. Coefficient:',
      value: proteinInfo?.extCoefficient,
    },
    {
      title: 'Seed:',
      value: seedInfo?.seedName,
    },
  ];

  const getFragmentVolume = () => {
    const drop = well.dropList?.find((d) => d.dropNumber === proteinInfo?.dropNumber);
    return drop ? drop.dropFragmentVolume : 0;
  };

  return (
    <div
      id="ingredientproteininfo-main-container"
      style={{ height: '68vh', overflow: 'auto' }}
    >
      {!isScreenRoute && (proteinInfo || seedInfo) && (
        <>
          <div
            id="ingredientproteininfo-display"
            className="proteininfoproperties"
            style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
          >
            {proteinInfoDisplay(proteinInfoArray)}
          </div>

          <div id="ingredientproteininfo-details-wrapper" style={{ padding: '15px' }}>
            <div
              id="ingredientproteininfo-details-protein"
              style={{ fontWeight: 'bold' }}
            >
              Protein Ingredients
            </div>

            <div id="ingredientproteininfo-details-protein-display">
              {proteinIngredientsHTML}
            </div>

            <div
              id="ingredientproteininfo-details-standard"
              style={{ fontWeight: 'bold' }}
            >
              Standard Ingredients
            </div>

            {standardIngredientHTML.length > 0 ? (
              <div id="ingredientproteininfo-details-standard-display">
                {standardIngredientHTML}
              </div>
            ) : null}
            <div id="ingredientproteininfo-details-fragment-title" style={{ fontWeight: 'bold' }}>Fragment</div>
            {fragmentIds?.length ? (
              <div id="ingredientproteininfo-details-fragment-info">
                <FragmentInfo
                  fragmentFragmentScreen={fragmentIds}
                  fragmentVolume={getFragmentVolume()}
                />
              </div>
            ) : null}
          </div>
        </>
      )}
    </div>
  );
}

export default IngredientProteinInfo;
